import { Link, useParams } from "react-router-dom";
import Item from "../models/item";
import Catalog from "./Catalog";
import { ModelDetails } from "../configuration/model-description";
import NotFound from "./NotFound";
import { Settings } from "../configuration/settings";
import { ModelCategories } from "../configuration/model-category";
import ModelCards from "../components/ModelCards";

function ModelCatalog(props: { items: Item[] }) {
    const { model } = useParams();
    const modelNumber = model ? Number(model) : null;

    if (!modelNumber || Number.isNaN(modelNumber)) {
        return <NotFound />
    }

    const modelDetails = ModelDetails[modelNumber];
    const filteredItems = props.items.filter(x => x.model == modelNumber);

    const modelCategory = ModelCategories.find(x => x.models.includes(modelNumber));

    return (
      <>
        <Catalog
          key={modelNumber} // hook to trigger React to re-create component
          items={filteredItems}
          outOfStocksVisible={true}
          title={`Levi’s ${modelNumber} ${modelDetails.fitName} Fit - купити чоловічі джинси в Україні | ${Settings.shopName}`}
          metaDescription={`Купуйте джинси Levi’s ${modelNumber} ${modelDetails.fitName} Fit - ${modelDetails.fitDescription[0].toLocaleLowerCase() + modelDetails.fitDescription.slice(1)}. Деталі моделі, розміри та швидка доставка по Україні в інтернет-магазині ${Settings.shopName}.`}
          canonicalRelativeUrl={`/m/levis-${modelNumber}`}
          breadcrumbs={[ { text: `${model}`, title: `Джинси Levi’s ${model}` } ]}
          header={`Джинси Levi’s ${modelNumber} ${modelDetails.fitName} Fit`}
          topHtml={modelDetails.catalogShortDescription}
          bottomHtml={modelDetails.catalogLongDescription}
          faq={{title: `Часті питання про чоловічі джинси Levi’s ${model}`, items: modelDetails.faq}}
        />
        <section className="text-secondary">
          <h2 className="fs-5">Інші популярні моделі джинсів Levi’s</h2>
          <p className="mb-2">
            Якщо Levi’s {modelNumber} вам не підходять або хочете подивитися інші схожі фасони, зверніть увагу на ці культові моделі:
          </p>
          <ModelCards exceptModels={[model!]} onlyModels={modelCategory?.models.map(x => String(x))} />
          <p>Всі моделі представлені в <strong>{Settings.shopName}</strong> з гарантованою автентичністю та доставкою по Україні.</p>
        </section>
      </>
    );
}

export default ModelCatalog;
